import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiBase';
import { setBotAdminToken } from '../../utils/botAdminApi';
import './BotAdmin.css';

const API_URL = getApiBaseUrl();

export default function BotAdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/bot-admin/login`, { password });
      if (data?.token) {
        setBotAdminToken(data.token);
        navigate('/bot-admin', { replace: true });
      } else {
        setErr('No token returned');
      }
    } catch (ex) {
      setErr(ex.response?.data?.error || ex.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ba-page ba-page--login">
      <div className="ba-card">
        <div className="ba-brand">
          <div className="ba-brand__mark" aria-hidden>⚙</div>
          <div className="ba-brand__text">
            <span className="ba-brand__tag">Console</span>
            <h1 className="ba-brand__title">Bot admin</h1>
          </div>
        </div>
        <p className="ba-sub">Sign in with the API server password.</p>
        <form onSubmit={onSubmit} className="ba-form">
          {err && <div className="ba-flash ba-flash--err" role="alert">{err}</div>}
          <label className="ba-label">
            Password
            <input
              type="password"
              className="ba-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <button type="submit" className="ba-btn ba-btn--primary" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
